<template>
  <div class="homecontainer" :class="{homeTitleDefalut:isZH,homeTitleEn:!isZH}">
    <div class="homecontainer-bg">
    </div>
    <div class="homecontainer-bg2">
    </div>
    <div class="homecontainer-content">
      <div class="title">
        <div class="icon-name">
          <img :src="require('../imgs/home_icon.svg')" alt="home_icon">
          <h1>Nook</h1>
        </div>
        <div class="title-info">
          <h1>{{ $t('home.title.title') }}</h1>
          <h2>{{ $t('home.title.desc') }}</h2>
        </div>
        <a href="https://apps.apple.com/app/id1671394841">
          <img class="ios-download" :src="require('../imgs/ios_download.svg')" alt="ios_download">
        </a>
      </div>
      <div class="feature-summary">
        <div class="summary-row">{{ $t('home.title.feature1') }}</div>
        <div class="summary-row">{{ $t('home.title.feature2') }}</div>
        <div class="summary-row">{{ $t('home.title.feature3') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeTitle',
  data () {
    return {
      isZH: (navigator.language || navigator.browserLanguage).toLowerCase().includes('zh-cn'),
      homeInfoImage: ''
    }
  },
  created () {
    this.homeInfoImage = this.isZH ? '' : '_en'
  }
}
</script>

<style lang="less" scoped>
  .homecontainer {
    width: 100%;
    min-height: 52.0625rem;
    background-color: #050505;
    display: flex;
    justify-content: center;
    align-items: center;
    @media only screen and (min-width: 501px) {
      .homecontainer-bg {
        position: absolute;
        width: 28.125rem;
        height: 28.125rem;
        left: 1.5%;
        top: -1.1875rem;
        background: #4B86DF;
        opacity: 0.5;
        filter: blur(12.71875rem);
        z-index: 1000;
      }
      .homecontainer-bg2 {
        position: absolute;
        width: 19.875rem;
        height: 19.875rem;
        left: 45.5%;
        top: 22.1875rem;
        background: #7D63FC;
        filter: blur(11.15625rem);
        z-index: 1000;
      }
    }
    .homecontainer-content {
      z-index: 2000;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80%;
      .title {
        justify-content: center;
        flex-direction: column;
        display: flex;
        padding-right: 5%;
        .icon-name {
          display: flex;
          h1 {
            margin-left: 1.15rem;
            font-family: 'Plus Jakarta Sans';
            font-style: normal;
            font-weight: 800;
            font-size: 4.75rem;
            line-height: 121.2%;
            display: flex;
            align-items: center;
            color: #FFFFFF;
          }
          img {
            width: 4.375rem;
            height: 4.375rem;
          }
        }
        .title-info {
          margin-top: 5.125rem;
          h1 {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 600;
            font-size: 4.75rem;
            line-height: 150%;
            display: flex;
            align-items: center;
            letter-spacing: -0.02em;
            background: linear-gradient(90deg, #D0F4FF 4.94%, #8571FF 103.87%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
          h2 {
            padding-top: 0.4375rem;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 600;
            font-size: 2.875rem;
            line-height: 121.2%;
            display: flex;
            align-items: center;
            color: #FFFFFF;
          }
        }
        a {
          .ios-download {
            margin-top: 2.625rem;
            width: 11.25rem;
            height: 3.75rem;
            float: left;
          }
        }
      }
      .feature-summary {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 36.875rem;
        min-height: 28rem;
        padding: 3rem;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 3rem;
        background: rgba(255, 255, 255, 0.08);
        backdrop-filter: blur(1rem);
        .summary-row {
          margin: 1rem 0;
          padding: 1.5rem;
          border-radius: 1.5rem;
          background: rgba(255, 255, 255, 0.08);
          color: #FFFFFF;
          font-size: 1.7rem;
          line-height: 1.5;
          text-align: left;
        }
      }
    }
  }
  @media only screen and (max-width: 500px){
    .homecontainer{
      .homecontainer-content{
        flex-direction: column;
        width: 100%;
        margin-top: 33px;
        .title{
          padding-right: 0;
          align-items: center;
          .icon-name{
            margin-top: 53px;
            margin-left: -15.5rem;
            img {
              width: 28px;
              height: 28px;
            }
            h1{
              margin-left: 7px;
              font-size: 10.816px;
            }
          }
          .title-info{
            margin-top: 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            h1{
              font-size: 43.776px;
            }
            h2 {
              padding-top: 3px;
              font-size: 26.496px;
              text-align: center;
            }
          }
          a {
            .ios-download {
              margin-top: 18px;
              width: 103px;
              height: 34px;
            }
          }
        }
        .feature-summary{
          margin-top: 24px;
          width: 292px;
          min-height: 220px;
          padding: 18px;
          border-radius: 24px;
          .summary-row {
            margin: 6px 0;
            padding: 10px;
            border-radius: 12px;
            font-size: 12px;
          }
        }
      }
    }
    &.homeTitleDefalut {
      min-height: 720px;
      height: 720px;
    }
    &.homeTitleEn {
      min-height: 720px;
      height: 720px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/subcomponents/HomeTitle.vue